<template>
	<div class="half_1_2">
		<div class="white_block_space white-block">
			<div class="patient-info-title wg_title">
				<div class="sched_plus" @click="showForms('cholesterol')"></div>
				<p>Холестерин</p>
			</div>
			<div class="patient-form cont_wg">
				<div class="patient-form-block pat_wg_box" v-for="item in cholesterol">
					<div class="formButton list" @click="selectRecord(item)">
						{{item.formName}}
					</div>
				</div>
				<div class="no_records_wg" v-if="!cholesterol.length">
					Еще не было добавлено записей в эту категорию
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Cholesterol",
		computed: {
			userId() {
				if(this.$route.query.patient) {
					return this.$route.query.patient
				}

				return this.$storage.get('user')
			},
			workerId() {
				return this.$route.query.doctor
			}
		},
		mounted(){
			this.$api.post('card/list', {
				"type": "cholesterol",
				"worker_id": this.workerId,
				"user_id": this.userId
			}).then(response => {
				this.analysis = response
			})
		},
		data() {
			return {
				cholesterol: []
			}
		}
	}
</script>
<style></style>



// WEBPACK FOOTER //
// Cholesterol.vue?7aca3453